import contactsHelper from './contacts';

export const validateBulkData = (data, locale) => {
    if (!data || data.length === 0) return null;
    const list = [];
    data.forEach(element => {
        element = convertToPluspointModel(element);
        contactsHelper.checkPhoneNumbers(element, locale, 'phoneNumber');
        contactsHelper.checkEmails(element, 'email');
        list.push(element);
    });
    const filteredEmptyValues = list.filter(item => item.phoneNumber || item.email);
    return checkUniqueContacts(filteredEmptyValues, 'phoneNumber');
};

const convertToPluspointModel = contact => {
    const { Mobile_Number, Email, First_Name, Last_Name, Instagram, Facebook, External_ID } = contact;
    return {
        phoneNumber: Mobile_Number,
        email: Email,
        firstName: First_Name,
        lastName: Last_Name,
        instagram: Instagram,
        facebook: Facebook,
        phoneValid: false,
        emailValid: false,
        externalId: External_ID,
    };
};

const checkUniqueContacts = (list, phone_field) => {
    const uniqueMap = {};
    const uniqueList = [];
    for (const contact of list) {
        if (!uniqueMap[contact[phone_field]]) {
            if (contact[phone_field]) uniqueMap[contact[phone_field]] = true;
            uniqueList.push(contact);
            continue;
        }
    }
    return uniqueList;
};

export const isDuplicate = (contact, duplicate) => {
    return (
        (contact.phoneNumber && duplicate.phoneNumber === contact.phoneNumber) ||
        (!contact.phoneNumber && !duplicate.phoneNumber && contact.email && duplicate.email === contact.email)
    );
};

export const findDuplicate = (contact, duplicates) => {
    const duplicatedContacts = duplicates?.filter(duplicate => isDuplicate(contact, duplicate));
    let duplicate = duplicatedContacts[0];
    if (duplicatedContacts.length > 1) {
        duplicate = duplicatedContacts
            .filter(duplicate => contact.email && duplicate.email === contact.email)
            .sort((a, b) => (a.createdDate > b.createdDate ? 0 : 1))[0];
    }
    return duplicate;
};

export const removeUnchangedContacts = (contacts, duplicates = []) => {
    const contactsForUpdate = [];
    contacts = contacts.filter(contact => {
        const duplicate = findDuplicate(contact, duplicates);
        let isChanged = false;
        if (duplicate) {
            isChanged =
                (contact.firstName && contact.firstName !== '-' && duplicate.firstName !== contact.firstName) ||
                (contact.lastName && contact.lastName !== '-' && duplicate.lastName !== contact.lastName) ||
                (contact.instagram && duplicate.instagram !== contact.instagram) ||
                (contact.facebook && duplicate.facebook !== contact.facebook) ||
                (contact.email && duplicate.email !== contact.email) ||
                (contact.externalId && duplicate.externalId !== contact.externalId);
        } else {
            isChanged = true;
        }
        if (isChanged && duplicate) {
            contactsForUpdate.push(duplicate);
        }
        return isChanged;
    });
    return { contacts, duplicates: contactsForUpdate };
};
